import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ChangeFillColorAction extends AbstractProvidedClass {
    oldColor;
    newColor;

    constructor(provider, appearance, colorPicker) {
        super(provider);

        this.appearance = appearance;
        this.colorPicker = colorPicker;
        this.oldColor = colorPicker.color();
    }

    finish() {
        this.newColor = this.colorPicker.color();
        this.newColor == this.oldColor
            ? this.actions.discard()
            : this.actions.finish();
        this.appearance.parent.row.updateImg();
    }

    undo() {
        this.appearance.fillColor = this.p.color(this.oldColor);
        this.appearance.parent.row.updateImg();
    }

    redo() {
        this.appearance.fillColor = this.p.color(this.newColor);
        this.appearance.parent.row.updateImg();
    }
}
